module.exports = {
  normal: "normal",
  eco: "eco",
  prm: "prm",
  xl: "xl",
  other: "other",
};
